<template>
  <div class="box">
    <div class="p-5 border-b border-gray-200 dark:border-dark-5">
      <h2 class="font-medium text-base">{{ $t('text.mainInformation') }}</h2>
    </div>
    <div class="p-5">
      <InputString
        :label="$t('text.familyName')"
        v-model.trim="vForm.familyName.$model"
        :vuelidate="vForm.familyName"
      />
      <InputString
        :label="$t('text.lastName')"
        v-model.trim="vForm.lastName.$model"
        :vuelidate="vForm.lastName"
      />
      <InputString
        :label="$t('text.firstName')"
        v-model.trim="vForm.firstName.$model"
        :vuelidate="vForm.firstName"
      />
      <InputString
        :label="$t('text.registrationNumber')"
        v-model.trim="vForm.registrationNumber.$model"
        :vuelidate="vForm.registrationNumber"
      />
      <InputString
        :label="$t('text.phone')"
        v-model.trim="vForm.phone.$model"
        :vuelidate="vForm.phone"
      />
      <InputString
        :label="$t('text.email')"
        v-model.trim="vForm.email.$model"
        :vuelidate="vForm.email"
      />
      <InputString
        :label="$t('text.facebookAddress')"
        v-model.trim="vForm.facebookAddress.$model"
        :vuelidate="vForm.facebookAddress"
      />
      <InputSelect
        :label="$t('text.isMarried')"
        :options="yesOrNo"
        value-key="id"
        v-model.number="form.isMarried"
      />
      <InputString :label="$t('text.familySize')" v-model="form.familySize" />
      <InputSelect
        :label="$t('text.educationDegree')"
        :options="degreeList"
        value-key="id"
        v-model.number="vForm.degreeId.$model"
        :vuelidate="vForm.degreeId"
      />
    </div>
  </div>
</template>

<script>
import InputString from '@/components/ui/input/InputString';
import InputSelect from '@/components/ui/input/InputSelect';

export default {
  props: {
    form: Object,
    vForm: Object,
    degreeList: Array,
  },

  components: {
    InputString,
    InputSelect,
  },

  data() {
    return {
      yesOrNo: [
        {
          id: 0,
          name: this.$t('text.no'),
        },
        {
          id: 1,
          name: this.$t('text.yes'),
        },
      ],
    };
  },
};
</script>
